var map = {
	"./ACB.svg": "f59e",
	"./ANZ1.svg": "ff88",
	"./BANVIET.svg": "ffa7",
	"./BIDV.svg": "1a38",
	"./BKAV1.svg": "4333",
	"./BVBANK.svg": "1b0b",
	"./CITIBANK.svg": "0ba6",
	"./EXIMBANK.svg": "2e14",
	"./FECREDIT.svg": "596a",
	"./HDBANK.svg": "f067",
	"./HOMECREDIT.svg": "c91b",
	"./HSBC.svg": "dca0",
	"./KIENLONGBANK.svg": "68eb",
	"./LIENVIETPOSTBANK.svg": "3b80",
	"./LOTTE_FINANCE.svg": "c5b1",
	"./MARITIMEBANK.svg": "f457",
	"./MBBANK.svg": "c416",
	"./MCREDIT.svg": "21aa",
	"./MIRAEASSET.svg": "81bc",
	"./MOMO1.svg": "a0f8",
	"./MUADEE1.svg": "3bef",
	"./NAMA.svg": "3263",
	"./NCB.svg": "c600",
	"./NHBQR1.svg": "4c25",
	"./OCB.svg": "081a",
	"./PVCOMBANK.svg": "6375",
	"./SACOMBANK.svg": "f1d2",
	"./SCB.svg": "840c",
	"./SEABANK.svg": "a8e5",
	"./SHB.svg": "028f",
	"./SHBVN.svg": "4f35",
	"./SHINHANFINANCE.svg": "e1df",
	"./SMARTPAY1.svg": "7710",
	"./STANDARDCHARTERED.svg": "603d",
	"./TECHCOMBANK.svg": "50cb",
	"./TPBANK.svg": "7345",
	"./UOB.svg": "768f",
	"./VIB.svg": "615a",
	"./VIETBANK.svg": "f2a0",
	"./VIETCOMBANK.svg": "3707",
	"./VIETINBANK.svg": "0ed4",
	"./VIETTELQR1.svg": "cc50",
	"./VIMOQR1.svg": "b069",
	"./VINID1.svg": "8e84",
	"./VISA QR1.svg": "1013",
	"./VPBANK.svg": "df1d",
	"./VietQR1.svg": "1f52",
	"./WECHAT1.svg": "91a7",
	"./WOORIBANK.svg": "8dbd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "235e";